var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvIcn2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.051,
    height: 74.625,
    viewBox: "0 0 74.051 74.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "env-icn2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2427",
    "data-name": "Groupe 2427",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 74.051,
    height: 74.625,
    rx: 20,
    fill: "rgba(255,186,70,0.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2654",
    "data-name": "Groupe 2654",
    transform: "translate(15.463 13.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2992",
    "data-name": "Trac\\xE9 2992",
    d: "M743.573,198.773a2.728,2.728,0,0,1-.261-.795q-.021-12.256-.011-24.512a1.519,1.519,0,0,1,1.707-1.719h8.635a1.516,1.516,0,0,1,1.712,1.715q0,12.256-.01,24.512a2.8,2.8,0,0,1-.255.8Z",
    transform: "translate(-728.312 -151.223)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2993",
    "data-name": "Trac\\xE9 2993",
    d: "M864.891,261.725a2.018,2.018,0,0,1-.285-.683q-.025-7.936-.01-15.872a1.449,1.449,0,0,1,1.558-1.569q4.455-.01,8.911,0a1.444,1.444,0,0,1,1.553,1.574q.009,7.936-.01,15.872c0,.226-.191.452-.293.678Z",
    transform: "translate(-834.585 -214.175)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2994",
    "data-name": "Trac\\xE9 2994",
    d: "M622.566,307.87c-.1-.226-.292-.451-.293-.677q-.029-4.685-.01-9.37a1.464,1.464,0,0,1,1.578-1.557q4.43-.007,8.86,0a1.463,1.463,0,0,1,1.582,1.551q.012,4.685-.01,9.37a2.03,2.03,0,0,1-.284.682Z",
    transform: "translate(-622.257 -260.32)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2995",
    "data-name": "Trac\\xE9 2995",
    d: "M741.363,6a6.153,6.153,0,0,1,.732.744c.525.746,1.023,1.512,1.509,2.284a1.5,1.5,0,0,0,.947.682c.941.248,1.878.511,2.813.781a1.021,1.021,0,0,1,.556,1.8c-.607.743-1.248,1.461-1.814,2.233a1.891,1.891,0,0,0-.351,1.05c0,.973.1,1.946.143,2.92.051,1.068-.582,1.525-1.566,1.135-.876-.347-1.753-.693-2.623-1.055a1.525,1.525,0,0,0-1.253.005c-.853.362-1.72.691-2.582,1.032-1.045.413-1.66-.031-1.6-1.165.047-.943.095-1.886.164-2.827a1.5,1.5,0,0,0-.383-1.148c-.623-.729-1.228-1.474-1.833-2.219a1,1,0,0,1,.544-1.739c.95-.275,1.9-.548,2.856-.8a1.555,1.555,0,0,0,.973-.722c.476-.76.966-1.512,1.483-2.245A6.213,6.213,0,0,1,740.806,6Z",
    transform: "translate(-720.065 -6)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2996",
    "data-name": "Trac\\xE9 2996",
    d: "M657.475,86.927a1.428,1.428,0,0,1-.8,1.237c-1.207.588-2.419,1.169-3.645,1.716a1.468,1.468,0,0,1-1.224-2.668c1.19-.587,2.388-1.162,3.6-1.7A1.481,1.481,0,0,1,657.475,86.927Z",
    transform: "translate(-647.421 -75.552)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2997",
    "data-name": "Trac\\xE9 2997",
    d: "M652.621,12.529a3.345,3.345,0,0,1,.528.167q1.681.777,3.351,1.578a1.482,1.482,0,1,1-1.279,2.662c-1.132-.53-2.266-1.058-3.39-1.6a1.47,1.47,0,0,1-.818-1.693A1.507,1.507,0,0,1,652.621,12.529Z",
    transform: "translate(-647.412 -11.72)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2998",
    "data-name": "Trac\\xE9 2998",
    d: "M882.159,16.92a1.5,1.5,0,0,1-1.531-1.052,1.389,1.389,0,0,1,.618-1.647c1.249-.638,2.514-1.25,3.8-1.811a1.462,1.462,0,0,1,1.214,2.645c-1.223.622-2.473,1.191-3.716,1.772A1.513,1.513,0,0,1,882.159,16.92Z",
    transform: "translate(-848.577 -11.528)",
    fill: "#ffaa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2999",
    "data-name": "Trac\\xE9 2999",
    d: "M886.944,88.618a1.441,1.441,0,0,1-1.984,1.347c-1.26-.542-2.5-1.144-3.718-1.772a1.461,1.461,0,0,1,1.236-2.631c1.271.557,2.521,1.164,3.764,1.782A1.352,1.352,0,0,1,886.944,88.618Z",
    transform: "translate(-848.546 -75.618)",
    fill: "#ffaa1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvIcn2);
export default __webpack_public_path__ + "static/media/env-icn2.4c1bdab84bed3229c653027e6fd8b17f.svg";
export { ForwardRef as ReactComponent };